import {createApp} from 'vue'
import App from './App.vue'
import router from './router'
import './styles/global.css'
import * as Sentry from '@sentry/vue'

const app = createApp(App)

Sentry.init({
	app,
	dsn: "https://7ea5dbf975e459792e032cd3866b3f48@o4510578387320832.ingest.de.sentry.io/4510580921008208",
})

app.use(router)
app.mount('#app')